<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
    class="large-dialog"
  >
    <el-form :model="formData" label-width="160px" :rules="formRules" ref="formRef" class="px-10px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="序号" prop="seqNo">
            <el-input-number
              v-model="formData.seqNo"
              :min="1"
              controls-position="right"
              :disabled="operateType === 'read'"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="上级功能" prop="parentId">
            <el-select
              ref="selectTree"
              popper-class="main-select-tree"
              v-model="formData.parentId"
              clearable
              filterable
              @clear="clearParentId"
              :disabled="operateType === 'read'"
            >
              <el-option
                v-for="item in formatData(treeData, [])"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
              <el-tree
                :data="treeData"
                node-key="id"
                highlight-current
                @node-click="handleNodeClick"
              ></el-tree>
            </el-select>
          </el-form-item>
          <el-form-item label="功能编码" prop="code">
            <el-input v-model="formData.code" :disabled="operateType === 'read'"></el-input>
          </el-form-item>
          <el-form-item label="功能名称" prop="name">
            <el-input v-model="formData.name" :disabled="operateType === 'read'"></el-input>
          </el-form-item>
          <el-form-item label="功能分类" prop="functionType">
            <el-select
              v-model="formData.functionType"
              :disabled="operateType === 'read'"
              filterable
              @change="changeFunctionType"
            >
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据展示位置" prop="functionLocationType">
            <el-select
              v-model="formData.functionLocationType"
              :disabled="operateType === 'read'"
              filterable
            >
              <el-option
                v-for="item in positionList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图标" prop="icon">
            <div class="flex items-center">
              <i
                :class="[fontFamily, cssPrefixText + formData.icon]"
                class="text-30px"
                v-if="this.formData.functionType === 1"
              ></i>
              <img :src="getSrc(formData.icon)" alt v-else />
              <el-button
                type="primary"
                size="small"
                :class="_.isEmpty(formData.icon) ? '' : 'ml-10px'"
                @click="chooseLabel"
                :disabled="operateType === 'read'"
                >选择</el-button
              >
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="标签" prop="lableIds">
            <el-transfer
              ref="myTransfer"
              :titles="['未选择', '已选择']"
              v-model="formData.lableIds"
              filterable
              filter-placeholder="请输入"
              :data="labelList"
            ></el-transfer>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="text-center" v-if="operateType !== 'read'">
      <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
    <el-dialog
      :visible.sync="labelVisible"
      title="选择图标"
      :close-on-click-modal="false"
      class="small-dialog"
      custom-class="choose-label-dialog"
      append-to-body
    >
      <div class="flex items-center my-10px">
        <el-input
          v-model="searchIconName"
          placeholder="请输入内容"
          suffix-icon="el-icon-search"
          clearable
        ></el-input>
        <span class="ml-15px text-16px">当前选择的是：</span>
        <i
          class="text-22px"
          :class="[fontFamily, cssPrefixText + chooseIconName]"
          v-if="this.formData.functionType === 1"
        ></i>
        <img
          :src="getSrc(chooseIconName)"
          alt
          class="h-30px w-30px"
          v-if="this.formData.functionType === 2 && chooseIconName"
        />
      </div>
      <div class="flex flex-wrap w-full h-320px">
        <template v-if="this.formData.functionType === 1">
          <div
            v-for="item in showIconfontList"
            :key="item['icon_id']"
            class="flex w-1/8 h-70px flex-col items-center justify-center mb-10px cursor-pointer rounded-5px"
            :class="{ 'bg-coolGray-400': item.isChoosed }"
            @click="toggleActiveIcon(item['font_class'])"
          >
            <i
              :class="[fontFamily, cssPrefixText + item['font_class']]"
              class="text-30px mb-8px"
            ></i>
            <el-tooltip effect="dark" :content="item['font_class']" placement="bottom">
              <div class="truncate w-4/5 text-center">{{ item['font_class'] }}</div>
            </el-tooltip>
          </div>
        </template>
        <template v-else>
          <div
            v-for="item in showimgList"
            :key="item.name"
            class="flex w-1/8 h-70px flex-col items-center justify-center mb-10px cursor-pointer"
          >
            <img
              :src="getSrc(item.icon, item.isChoosed)"
              class="h-30px w-30px mb-8px"
              alt
              @click="toggleActive(item.icon)"
            />
            <div>{{ item.name }}</div>
          </div>
        </template>
      </div>
      <div class="mt-20px flex justify-end">
        <el-pagination
          background
          :current-page.sync="page.pageNo"
          :total="page.total"
          :page-size="page.pageSize"
          layout="total, prev, pager, next"
        ></el-pagination>
      </div>
      <div slot="footer" class="text-center">
        <el-button type="primary" size="small" @click="saveLabel">保存</el-button>
        <el-button size="small" @click="labelVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { FunctionInfoApi, LableApi } from '@wiz-api/cloud-render-management'

const functionApi = new FunctionInfoApi()
const labelApi = new LableApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    operateProps: {
      type: Object,
      default: () => {},
    },
    operateType: {
      type: String,
      default: 'create',
    },
    positionList: {
      type: Array,
      default: () => {
        return []
      },
    },
    iconfontJSON: {
      type: Object,
      default: () => {},
    },
    fontFamily: {
      type: String,
      default: '',
    },
    cssPrefixText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        seqNo: '',
        parentId: null,
        code: '',
        name: '',
        functionType: '',
        functionLocationType: '',
        icon: '',
        lableIds: [],
      },
      formRules: {
        seqNo: { required: true, message: '请输入序号', trigger: 'blur' },
        code: { required: true, message: '请输入功能编码', trigger: 'blur' },
        name: { required: true, message: '请输入功能名称', trigger: 'blur' },
        functionType: { required: true, message: '请选择功能分类', trigger: 'blur' },
        functionLocationType: { required: true, message: '请选择数据展示位置', trigger: 'blur' },
        icon: { required: true, message: '请输入功能名称', trigger: 'blur' },
      },
      typeList: [
        {
          value: 1,
          label: '基础功能',
        },
        {
          value: 2,
          label: '业务功能',
        },
      ],
      labelList: [],
      treeData: [],
      labelVisible: false,
      imgList: [
        {
          icon: '3DSis',
          name: '三维SIS',
          isChoosed: false,
        },
        {
          icon: 'dailyInspection',
          name: '日常巡检',
          isChoosed: false,
        },
        {
          icon: 'intelligentDefense',
          name: '智能安防',
          isChoosed: false,
        },
        {
          icon: 'metalDetection',
          name: '金属检测',
          isChoosed: false,
        },
        {
          icon: 'jobSafety',
          name: '作业安全',
          isChoosed: false,
        },
        {
          icon: 'personPosition',
          name: '人员定位',
          isChoosed: false,
        },
        {
          icon: 'emergencyDisposal',
          name: '应急处置',
          isChoosed: false,
        },
        {
          icon: 'emergencySupplies',
          name: '应急物资',
          isChoosed: false,
        },
        {
          icon: 'counterFloodControl',
          name: '防台防汛',
          isChoosed: false,
        },
        {
          icon: 'riskArea',
          name: '风险区域',
          isChoosed: false,
        },
        {
          icon: 'monitorEquipment',
          name: '监控设备',
          isChoosed: false,
        },
        {
          icon: 'fence',
          name: '门禁设备',
          isChoosed: false,
        },
        {
          icon: 'doubleTicket',
          name: '两票作业',
          isChoosed: false,
        },
        {
          icon: 'hiddenRisk',
          name: '风险隐患',
          isChoosed: false,
        },
        {
          icon: 'antiSandBox',
          name: '安防沙盘',
          isChoosed: false,
        },
        {
          icon: 'fireBIM',
          name: '消防BIM',
          isChoosed: false,
        },
        {
          icon: 'illuminatingBIM',
          name: '照明BIM',
          isChoosed: false,
        },
      ],
      searchIconName: '',
      page: {
        pageNo: 1,
        pageSize: 32,
        total: 0,
      },
      currentParentName: '',
      chooseIconName: '',
      iconfontList: [],
    }
  },
  async created() {
    await this.getLabelList()
    await this.getSubTreeList()
    this.iconfontList = _.map(this.iconfontJSON.glyphs, (item) => {
      return {
        ...item,
        isChoosed: false,
      }
    })
    // 编辑查看
    if (!_.isEmpty(this.operateProps)) {
      this.formData = _.cloneDeep(this.operateProps)
      // 回填图标
      if (this.operateProps.functionType === 1) {
        _.forEach(this.iconfontList, (item) => {
          if (item.font_class === this.operateProps.icon) {
            item.isChoosed = true
          }
        })
      } else {
        _.forEach(this.imgList, (item) => {
          if (item.icon === this.operateProps.icon) {
            item.isChoosed = true
          }
        })
      }
      this.chooseIconName = this.operateProps.icon
      this.$set(this.formData, 'lableIds', this.operateProps.extraDto.lableIds)
    }
  },
  computed: {
    // 弹框标题
    title() {
      switch (this.operateType) {
        case 'create':
          return '新增'
        case 'read':
          return '查看'
        default:
          return '编辑'
      }
    },
    // 展示的图片列表
    showimgList() {
      const result = _.filter(this.imgList, (item) => {
        if (!_.includes(item.name, this.searchIconName)) {
          return false
        }
        return true
      })
      this.page.total = result.length
      return result.slice(
        (this.page.pageNo - 1) * this.page.pageSize,
        this.page.pageNo * this.page.pageSize
      )
    },
    // 展示的icon列表
    showIconfontList() {
      const result = _.filter(this.iconfontList, (item) => {
        if (!_.includes(item.name, this.searchIconName)) {
          return false
        }
        return true
      })
      this.page.total = result.length
      return result.slice(
        (this.page.pageNo - 1) * this.page.pageSize,
        this.page.pageNo * this.page.pageSize
      )
    },
  },
  methods: {
    // 获取标签列表
    async getLabelList() {
      const [err, res] = await labelApi.getList({
        name: '',
        code: '',
        maxResultCount: 1000,
        skipCount: 0,
      })
      if (!err && res) {
        this.labelList = _.map(res.items, (item) => {
          if (this.operateType !== 'read') {
            return {
              key: item.id,
              label: item.name,
            }
          }
          return {
            key: item.id,
            label: item.name,
            disabled: true,
          }
        })
      }
    },
    // 获取上级功能树形结构
    async getSubTreeList() {
      const [err, res] = await functionApi.getSubTrees()
      if (!err && res) {
        this.treeData = this.getTreeList(res)
      }
    },
    // 树形化
    getTreeList(data) {
      const res = []
      _.forEach(data, (item) => {
        const obj = {
          id: item.id,
          label: item.detail.name,
        }
        if (!_.isEmpty(item.children)) {
          obj.children = this.getTreeList(item.children)
        }
        res.push(obj)
      })
      return res
    },
    // 扁平化树形
    formatData(data, arr) {
      _.forEach(data, (item) => {
        arr.push({
          value: item.id,
          label: item.label,
        })
        if (!_.isEmpty(item.children)) {
          this.formatData(item.children, arr)
        }
      })
      return arr
    },
    // 下拉框点击树形节点回调数据
    handleNodeClick(node) {
      this.formData.parentId = node.id
      this.currentParentName = node.label
      this.$refs.selectTree.blur()
    },
    // 清空父级id下拉框时置为null
    clearParentId() {
      this.formData.parentId = null
    },
    // 点击选择图标
    chooseLabel() {
      if (this.formData.functionType === '') {
        return this.$message({
          showClose: true,
          message: '请先选择功能分类',
          type: 'warning',
        })
      }
      this.labelVisible = true
    },
    // 获取图片地址
    getSrc(name, isChoosed = false) {
      let res = ''
      if (!_.isEmpty(name)) {
        try {
          res = require(`../../../visualization-cockpit/assets/images/tab/${name}${
            isChoosed ? '_checked' : '_uncheck'
          }.png`)
        } catch (error) {
          return ''
        }
      }
      return res
    },
    // 切换图片选中
    toggleActive(icon) {
      this.chooseIconName = icon
      _.forEach(this.imgList, (item) => {
        if (icon === item.icon) {
          item.isChoosed = true
        } else {
          item.isChoosed = false
        }
      })
    },
    // 切换icon选中
    toggleActiveIcon(name) {
      this.chooseIconName = name
      _.forEach(this.iconfontList, (item) => {
        if (name === item.font_class) {
          item.isChoosed = true
        } else {
          item.isChoosed = false
        }
      })
    },
    // 分类类型切换
    changeFunctionType() {
      this.formData.icon = ''
      this.chooseIconName = ''
      // 取消上一次的选中状态
      this.iconfontList = _.map(this.iconfontList, (item) => {
        return {
          ...item,
          isChoosed: false,
        }
      })
      this.imgList = _.map(this.imgList, (item) => {
        return {
          ...item,
          isChoosed: false,
        }
      })
    },
    // 保存选择的图标
    saveLabel() {
      this.formData.icon = this.chooseIconName
      this.labelVisible = false
    },
    // 保存新增编辑结果
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          let err = null
          let res = {}
          if (_.isEmpty(this.operateProps)) {
            // 新增
            ;[err, res] = await functionApi.create({
              body: {
                ...this.formData,
                extraProperties: {
                  lableIds: this.formData.lableIds.join(','),
                },
              },
            })
          } else {
            // 编辑
            if (this.currentParentName === _.trim(this.formData.name)) {
              this.saveLoading = false
              return this.$message({
                showClose: true,
                message: '上级功能不能是该功能本身',
                type: 'error',
              })
            }
            ;[err, res] = await functionApi.update(this.operateProps.id, {
              body: {
                ...this.formData,
                extraProperties: { lableIds: this.formData.lableIds.join(',') },
              },
            })
          }
          if (!err && res) {
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success',
            })
            this.$emit('update:visible', false)
            this.$emit('refresh')
          }
          this.saveLoading = false
        }
      })
    },
    // 关闭弹框
    handleClose() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  .el-input,
  .el-select,
  .el-input-number {
    max-width: 440px;
    width: 100%;
    line-height: 36px;
    .el-input__inner {
      text-align: left;
    }
    .el-input-number__decrease {
      line-height: 18px;
    }
    .el-input-number__increase {
      line-height: 17px;
    }
  }
  .el-transfer-panel__filter {
    width: auto;
  }
  .el-transfer-panel {
    width: 175px;
  }
  .el-transfer__buttons {
    padding: 0 15px;
    .el-transfer__button + .el-transfer__button {
      margin-left: 0;
    }
  }
}
::v-deep .choose-label-dialog.el-dialog {
  .el-input {
    width: 200px;
  }
}
</style>

<style lang="scss">
.main-select-tree {
  .el-select-dropdown__item {
    display: none;
  }
}
</style>
